import * as URLConfig from "@frameworks/web/config/domain";
var config = URLConfig.config;
var basicprofilebase = config.jmw_market_env + config.jmw_market + "profile/"; //will be deprecated in future
var basicprofilebase2 = config.jmw_market_env + config.appClient; // will be used in future for all basic profile apis
var leadBase = config.jmw_market_env + config.jmw_market + "lead/";
var serviceRequest = "servicerequest";
var BasicProfileURL = {
    clientNRIUrl: config.jmwedel + config.jmw_login + "sr/clientcategory",
    getBrokerageSegments: config.jmw + basicprofilebase2 + "client/profile/brokerage",
    nomineeDetails: config.jmw + config.jmw_login + "sr/getnomineedetails",
    advisorRating: config.jmw + basicprofilebase2 + "client/profile/raterm/submit/",
    clientDetails: config.jmw + basicprofilebase2 + "client/profile/",
    deviceRegister: config.jmw + config.jmw_login + "devices/register",
    getRegisteredDevices: config.jmw + config.jmw_login + "devices/registered",
    deRegisterDevice: config.jmw + config.jmw_login + "devices/deregister",
    getProfilePicture: config.jmw + basicprofilebase2 + "client/profile/pic",
    saveprofilepicture: config.jmw + basicprofilebase2 + "client/profile/pic",
    deleteProfilePicture: config.jmw + basicprofilebase2 + "client/profile/pic",
    viewCommunicationDetails: config.jmw + basicprofilebase + "viewCommSettings",
    saveCommunicationDetails: config.jmw + basicprofilebase + "saveCommSettings",
    getRmDetails: config.jmw + basicprofilebase2 + "client/profile/rm",
    whatsappConsent: config.jmw + config.jmw_login + "consent/whatsapp",
    downloadKYCData: config.jmw + basicprofilebase2 + "client/profile/download-kyc-pdf",
    defaultExchange: config.jmw + config.jmw_eq + "client-details/default-exchange",
    wealthAdvisor: config.jmw + basicprofilebase2 + "client/profile/wealth-advisor",
    savelead: config.jmw + leadBase + "saveleadinfo_v1",
    deleteUpi: config.jmw + config.jmw_eq + "fund/upi/",
    generateSecretKeyEtotp: config.jmw + config.jmw_login + "etotp/generate/secretkey",
    validateSecretKeyEtotp: config.jmw + config.jmw_login + "etotp/validate/secretkey",
    passwordVerifyDisableEtotp: config.jmw + config.jmw_login + "account/validateuidpwd",
    disableEtotp: config.jmw + config.jmw_login + "etotp/disable",
    disableEtotpGenerateOtp: config.jmw + config.jmw_login + "etotp/send/otp",
    changePassword: config.jmw + config.jmw_login + "accounts"
};
export default BasicProfileURL;
